import React from 'react'
import "./About.css"
import { Link } from "react-router-dom";


const About = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <img src="/logo.png" alt="logo" />
          <h5 className="mb-0">
            <span>SVT</span><br />
            DIGITAL INFO TECH
          </h5>
      
          {/* Toggler Button */}
          <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
      
          {/* Collapse menu */}
              <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
             <Link className="nav-link" to="/">
        <i className="fa-solid fa-house"></i> HOME
      </Link>
              </li>
      
              <li className="nav-item dropdown">
              <Link
        className="nav-link dropdown-toggle"
        to="#"
        id="navbarDropdownMenuLink"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i className="fa-solid fa-desktop"></i> SERVICES
      </Link>
      
                <ul
                  className="dropdown-menu p-3 custom-dropdown"
                  aria-labelledby="navbarDropdownMenuLink"
                  style={{ minWidth: '600px' }}
                >
                  <div className="row">
                    <div className="col-6">
      <li>
        <Link className="dropdown-item" to="/website">
          <i className="fa-solid fa-desktop"></i> Website
        </Link>
      </li>               <li>
        <Link className="dropdown-item" to="/graphicwork">
          <i className="fa-solid fa-fire"></i> Graphic Work
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/ecommerce">
          <i className="fa-solid fa-cart-shopping"></i> Ecommerce Development
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/software">
          <i className="fa-solid fa-tv"></i> Software Development
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/business">
          <i className="fa-solid fa-chart-line"></i> Business Consulting
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/erp">
          <i className="fa-solid fa-computer"></i> ERP Software
        </Link>
      </li>
                    </div>
                    <div className="col-6">
                     <li>
        <Link className="dropdown-item" to="/search">
          <i className="fa-solid fa-rocket"></i> Search Engine Optimization
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/digitalmarketing">
          <i className="fa-solid fa-satellite-dish"></i> Digital Marketing
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/socialmedia">
          <i className="fa-brands fa-hubspot"></i> Social Media Management
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/lead">
          <i className="fa-solid fa-network-wired"></i> Lead Generation
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/businessbrand">
          <i className="fa-solid fa-tag"></i> Business Branding
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/hr">
          <i className="fa-brands fa-searchengin"></i> HR Services
        </Link>
      </li>
                    </div>
                  </div>
                </ul>
              </li>
      
              <li className="nav-item">
              <Link className="nav-link" to="/about">
        <i className="fa-solid fa-circle-info"></i> ABOUT US
      </Link>
              </li>
      
              <li className="nav-item">
            <Link className="nav-link" to="/form">
        <i className="fa-solid fa-address-book"></i> CONTACT
      </Link>
              </li>
      
            </ul>
          </div>
        </div>
      </nav>
      

        <div className='firstss'>
      <img src='/logo.png' alt='' />
      <h1>Our Journey – From Digital Services to Digital Skills</h1>
      </div>

<div class="timeline-container">
  <div class="timeline-item">
    <div class="timeline-marker"></div>
    <div class="timeline-content">
      <h3><strong>Founded in 2020</strong>, SVT Digital Info Tech began as a passionate digital marketing service startup in Tirupur, helping all small, medium & big businesses to grow online through branding, website Designs, SEO, social media, and performance marketing. With real-time client projects and strong results, we quickly built a name as a reliable digital partner for local businesses.</h3>
    </div>
  </div>

  <div class="timeline-item">
    <div class="timeline-marker"></div>
    <div class="timeline-content">
      <h3><strong>In 2023</strong>, inspired by the increasing demand for digital skills and career-focused learning, we expanded into professional training, bringing our practical industry knowledge into classrooms.</h3>
    </div>
  </div>

  <div class="timeline-item">
  <div class="timeline-marker"></div>
  <div class="timeline-content">
    <h3><strong>Now, SVT Digital Info Tech is proud to offer hands-on training in:</strong></h3>
    <ul class="timeline-list">
      <li>🔹 Digital Marketing</li>
      <li>🔹 Website Design</li>
      <li>🔹 Data Analysis</li>
      <li>🔹 Social Media Marketing - Facebook & Instagram</li>
      <li>🔹 Google & YouTube Advertisements</li>
      <li>🔹 Business Branding</li>
      <li>🔹 Graphic Design, UI/UX</li>
      <li>🔹 Spoken English & Hindi</li>
      <li>🔹 Video Editing & Photoshop</li>
      <li>🔹 Java, Python, PHP, Front-End, Back-End Programming</li>
      <li>🔹 Many more in Computer Education</li>
    </ul>
  </div>
</div>
</div>

<div className='nextcont'>
    <h3>
  With trainers who hold 10+ years of industry experience,<br/>
  we’re bridging the gap between education and employability —<br/>
  empowering students, job seekers, homemakers, and entrepreneurs alike.
</h3>

<h1>"We don’t just teach digital skills — we build digital careers."</h1>

</div>


<footer class="bg-dark text-white pt-4 pb-2">
<div style={{ position: '', width: '100%', height: 'auto', overflow: 'hidden' }}>


  <div class="container text-center text-md-left">
    <div class="row">

    
<div class="col-md-4 mb-3 d-flex flex-column align-items-center">
  <h3 class="text-center">QUICK LINKS</h3>
  <ul class="quick-links list-unstyled text-center p-0 m-0">
    <li><a href="/" class="text-white text-decoration-none d-block mb-1">Website Designing </a></li>
    <li><a href="/courses" class="text-white text-decoration-none d-block mb-1">Graphic Work</a></li>
    <li><a href="/contact" class="text-white text-decoration-none d-block mb-1">E-Commerce Development</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Software Development</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Business Consulting</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">ERP Software</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Search Engine Optimization</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Digital Marketing</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Social Media Management</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Lead Generation</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Business Branding</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">HR Services</a></li>
  </ul>
</div>


<div class="col-md-4 mb-3">
  <h3 class="text-center">ADDRESS</h3>
  <p class="contact-info text-start">
    📍 Kongu Main Rd, near Bharat Petrol Bunk, MS Nagar, Tiruppur, Tamil Nadu 641607<br/>
    📞 99168 28514<br/>
    📧 svtdigiinfo@gmail.com
  </p>
</div>

 <div class="col-md-4 mb-3">
    <h3> SOCIAL MEDIA</h3>

<div>
<a
  href="https://wa.me/919916828514"  
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="fa-brands fa-whatsapp"></i>
</a>
<a href="https://www.facebook.com/profile.php?id=61575077092918" target="_blank">
  <i class="fa-brands fa-facebook"></i>
</a>
</div>
<div className='second'>
<a href="https://www.instagram.com/svt_digital_academy/" target="_blank">
  <i class="fa-brands fa-instagram"></i>
</a> 

<a href="https://www.youtube.com/@SVTDigitalinfotech" target="_blank">
  <i class="fa-brands fa-youtube"></i>
</a>
</div>

      </div>

    </div>

    <hr class="custom-hr" />


    <div class=" mt-3">
      <h5>Terms and condition | <Link to="/privacy" className="customlink">Privacy policy</Link>
 <br/>
Copyright ©svt digital info tech. All Rights Reserved.</h5>
    </div>

  </div>
  </div>

</footer>







    </div>
  )
}

export default About
